import {
  ExamLocationRequestRoomPhysicalInfoForm,
  ExamRoomRequestPhysicalInfoDetails,
  mapPhysicalInfoToDefaultValues,
  useExamRoomRequestInfo,
} from '@exam-center/exam-location-management';
import { ExamLocationRequestWorkflowStepCode } from '@exam-center/graphql';
import { PaperSection } from '@shared/components';

export default function ExamLocationRequestRoomPhysicalInfoPage() {
  const { examRoomRequestInfo, isReadonly } = useExamRoomRequestInfo();

  const defaultValues = mapPhysicalInfoToDefaultValues(
    examRoomRequestInfo.examRoomRequestPhysicalInfo?.info,
  );

  return (
    <PaperSection title='ข้อมูลทางกายภาพ'>
      {examRoomRequestInfo.step ===
      ExamLocationRequestWorkflowStepCode.ExamLocationRequestRejected ? (
        <ExamLocationRequestRoomPhysicalInfoForm
          isReadonly={isReadonly}
          defaultValues={defaultValues}
        />
      ) : (
        <ExamRoomRequestPhysicalInfoDetails />
      )}
    </PaperSection>
  );
}
